import { CanonicalInterval } from 'src/types';
import { SwitchSimple } from 'src/v2/commonComponents/SwitchSimple';
import { usePaymentControlActions, usePaymentControlState } from 'src/hooks';
import styles from './PeriodSwitch.module.scss';

interface PeriodSwitchProps {
  onCloseCheckout: () => void;
}

export const PeriodSwitch = ({ onCloseCheckout }: PeriodSwitchProps) => {
  const { selectedPeriod } = usePaymentControlState();
  const { onSetSelectedPeriod } = usePaymentControlActions();

  const handleSwitchChange = (value: boolean) => {
    onSetSelectedPeriod(
      value ? CanonicalInterval.ANNUALLY : CanonicalInterval.MONTHLY,
    );
    onCloseCheckout();
  };

  return (
    <div className={styles.root}>
      <div className={styles.saleLabelWrapper}>
        <p className={styles.saleLabelText}>Billed annually</p>

        <span className={styles.saleLabel}>2 months off</span>
      </div>

      <SwitchSimple
        isChecked={selectedPeriod === CanonicalInterval.ANNUALLY}
        onChange={handleSwitchChange}
      />
    </div>
  );
};
